module.exports = __webpack_public_path__ + "img/我的项目-分享管理.9b7445f1.png";